var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE5\x85\xB3\xE9\x97\xAD"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.78226 3.075C3.587 2.87974 3.27042 2.87974 3.07516 3.075C2.8799 3.27027 2.8799 3.58685 3.07516 3.78211L7.29302 7.99998L3.07516 12.2178C2.8799 12.4131 2.8799 12.7297 3.07516 12.925C3.27042 13.1202 3.587 13.1202 3.78226 12.925L8.00013 8.70708L12.218 12.925C12.4133 13.1202 12.7298 13.1202 12.9251 12.925C13.1204 12.7297 13.1204 12.4131 12.9251 12.2178L8.70724 7.99998L12.9251 3.78211C13.1204 3.58685 13.1204 3.27027 12.9251 3.075C12.7298 2.87974 12.4133 2.87974 12.218 3.075L8.00013 7.29287L3.78226 3.075Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.593710ea7526e1a70070c33387a2bda3.svg";
export { ForwardRef as ReactComponent };